import {
  baseNavigation,
  baseNavigationManager,
  baseNavigationMonitoring,
} from 'app/navigation';
import { useMemo } from 'react';

export const useAppModule = () => {
  const module =
    import.meta.env.VITE_REACT_APP_MODULE?.toUpperCase() || 'MONITORING';

  const isMonitoring = useMemo(() => module === 'MONITORING', [module]);
  const isIndustrial = useMemo(() => module === 'INDUSTRIAL', [module]);
  const isManager = useMemo(() => module === 'MANAGER', [module]);

  const NAVIGATION = {
    INDUSTRIAL: baseNavigation,
    MONITORING: baseNavigationMonitoring,
    MANAGER: baseNavigationManager,
  };

  const navigation = NAVIGATION[module] || baseNavigation;

  return { module, isMonitoring, isIndustrial, isManager, navigation };
};
